import posthog from "posthog-js";

const POSTHOG_KEY =
  (import.meta.env.NEXT_PUBLIC_POSTHOG_KEY as string | undefined) ||
  (import.meta.env.VITE_POSTHOG_KEY as string | undefined) ||
  "";

const POSTHOG_HOST =
  (import.meta.env.NEXT_PUBLIC_POSTHOG_HOST as string | undefined) ||
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ||
  "https://eu.i.posthog.com";

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  if (!POSTHOG_KEY) return;
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      ui_host: POSTHOG_HOST,
      person_profiles: "always",
      capture_pageview: false,
      capture_pageleave: false,
      autocapture: false,
      disable_session_recording: true,
    });
    initialized = true;
  } catch {
    // swallow — analytics must never break the widget
  }
}

export type TrackProps = Record<string, unknown>;

export function track(event: string, properties?: TrackProps) {
  if (!initialized) return;
  try {
    posthog.capture(event, {
      ...properties,
      project: "kis-way-chat",
      host_origin: typeof window !== "undefined" ? window.location.origin : undefined,
      host_pathname: typeof window !== "undefined" ? window.location.pathname : undefined,
    });
  } catch {
    // swallow
  }
}

export const AnalyticsEvents = {
  WidgetLoaded: "way-match_widget_loaded",
  ClickedFAB: "way-match_clicked_FAB",
  ClosedChat: "way-match_closed_chat",
  SelectedYear: "way-match_selected_year",
  SelectedCurriculum: "way-match_selected_curriculum",
  SelectedSubject: "way-match_selected_subject",
  ConfirmedContact: "way-match_confirmed_contact",
  EnterSearchDetails: "way-match_enter_search_details",
  SubmittedDetails: "way-match_submitted_details",
  SearchStarted: "way-match_search_started",
  TutorsListed: "way-match_tutors_listed",
  NoTutorsFound: "way-match_no_tutors_found",
  SearchFailed: "way-match_search_failed",
  TutorCardClicked: "way-match_tutor_card_clicked",
  SearchAgain: "way-match_search_again",
  ViewDetailedResultsClicked: "way-match_view_detailed_results_clicked",
  RedirectedToDetailedResults: "way-match_redirected_to_detailed_results",
  RedirectedToBrowseAllTutors: "way-match_redirected_to_browse_all_tutors",
  RedirectedToBrowseSubjectTutors: "way-match_redirected_to_browse_subject_tutors",
} as const;
